import * as S from "../../Style/Page/Car.style.js";
import { Link } from "react-router-dom";
import { ReactComponent as Home } from "../../assets/icon/home.svg";
import Arrow from "../../assets/icon/lnb_arrow.png";
import PageTitle from "../../Component/PageTitleCar.js";
import HatPageTopLine from "../../Component/CarPageTopLine.js";
// const FactoryImg1 = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/43. 카자흐스탄 공장.b18d2245c93391d708e5.png`;
import FactoryImg1 from "../../assets/BusBusiness/카자흐스탄공장.png";
import Bus1 from "../../assets/BusBusiness/BS106.png";
import Bus2 from "../../assets/BusBusiness/G12.png";
// const Bus1 = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/사진 15.7e5899fe239aeaf3a011.png`;
// const Bus1_1 = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/44. 카자흐스탄 공장 GDW6121.7d2ddd8ee3af4af52ecb.png`;
// const Bus2 = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/45. 카자흐스탄 공장 BS106.d2cad79cdb3cab6e2344.png`;
// const Bus3 = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/사진 16.7519bc4b5341276de395.png`;
const FactoryInner = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/사진 14.9d00cc18190de4280244.jpg`;
const Factory5 = () => {
  return (
    <S.Page className={localStorage.getItem("language")}>
      <HatPageTopLine name={"상용버스사업"} />
      <section className="section" id="hat-introduce-section">
        <S.PageNavidation>
          <Link to="/" className="logo">
            <Home />
          </Link>
          <S.Nav height={"364px"}>
            <S.NavItem>
              <Link to="/BusBusiness/OverseasBus">
                <div className="kor">버스사업</div>
                <div className="eng">Bus Business</div>
              </Link>
            </S.NavItem>

            <div className="open-list">
              <S.NavItem className="list-inner-item">
                <Link to="/HatBusiness/Introduce">
                  <div className="kor">모자사업</div>
                  <div className="eng">Hat Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/ForkLiftBusiness/Introduce">
                  <div className="kor">지게차사업</div>
                  <div className="eng">Fork Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/CarBusiness/introduce">
                  <div className="kor">자동차사업</div>
                  <div className="eng">Car Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/BusBusiness/OverseasBus">
                  <div className="kor">버스사업</div>
                  <div className="eng">Bus Business</div>
                </Link>
              </S.NavItem>

              <S.NavItem className="list-inner-item">
                <Link to="/GeneralBusiness/introduce">
                  <div className="kor">일반사업</div>
                  <div className="eng">General Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/SocialBusiness/SocialService">
                  <div className="kor">사회사업</div>
                  <div className="eng">Social Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/WBH/WBH">WBH</Link>
              </S.NavItem>
            </div>
            <img src={Arrow} className="down-arrow" alt="" />
          </S.Nav>

          <S.Nav height={"156px"}>
          <S.NavItem>
              <Link to="/BusBusiness/Factory">
                <div className="kor">생산공장</div>
                <div className="eng">production plant</div>
              </Link>
            </S.NavItem>
            <div className="open-list">
              <S.NavItem className="list-inner-item">
                <Link to="/BusBusiness/OverseasBus">
                  <div className="kor">해외 상용버스사업</div>
                  <div className="eng">Overseas commercial bus business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/BusBusiness/Factory">
                  <div className="kor">생산공장</div>
                  <div className="eng">production plant</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/BusBusiness/BusBusinessHistory">
                  <div className="kor">버스사업이력</div>
                  <div className="eng">Major business history</div>
                </Link>
              </S.NavItem>
            </div>
            <img src={Arrow} className="down-arrow" alt="" />
          </S.Nav>

          <S.Nav height={"312px"}>
            <S.NavItem>
              <Link to="/BusBusiness/Factory5">
                <div className="kor">카자흐스탄 공장</div>
                <div className="eng">Kazakhstan Production Plant</div>
              </Link>
            </S.NavItem>
            <div className="open-list">
              <S.NavItem className="list-inner-item">
                <Link to="/BusBusiness/Factory">
                  <div className="kor">베트남 생산공장</div>
                  <div className="eng">Vietnam Production Plant</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/BusBusiness/Factory2">
                  <div className="kor">베트남 부품공장</div>
                  <div className="eng">Vietnam Parts Manufacturing</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/BusBusiness/Factory3">
                  <div className="kor">중국 계림 법인</div>
                  <div className="eng">China Production Plant</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/BusBusiness/Factory4">
                  <div className="kor">파키스탄 공장</div>
                  <div className="eng">Pakistan Production Plant</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/BusBusiness/Factory5">
                  <div className="kor">카자흐스탄 공장</div>
                  <div className="eng">Kazakhstan Production Plant</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/BusBusiness/Factory6">
                  <div className="kor">코스타리카 법인</div>
                  <div className="eng">Costa Rica Sales Corporation</div>
                </Link>
              </S.NavItem>
            </div>
            <img src={Arrow} className="down-arrow" alt="" />
          </S.Nav>
        </S.PageNavidation>
        <div className="wrap">
          <div className="inner">
            <PageTitle
              titleko={"카자흐스탄 공장"}
              titleeng={"Production Plant"}
              website={"https://daewoobus.kz/ru"}
            />
            <div className="page-text"><h2>Daewoo Bus Kazakhstan LLC.</h2></div>
            <S.ImgHolderFullsize>
              <img src={FactoryImg1} className="holder-img" alt="" />
              <div className="holder-name">
                <div className="kor">카자흐스탄 공장</div>
                <div className="eng">Daewoo Kazakhstan</div>
              </div>
            </S.ImgHolderFullsize>
            <PageTitle titleko={"공장 내부 / 주요 생산 / 판매차종"} titleeng={"Factory Interior / Major Product / Sales model"} />
            <S.ImgHolderFlex className="start">
              <S.ImgHolderHarf>
                <img src={FactoryInner} className="holder-img" alt="" />
                <div className="holder-name">
                  <div className="kor">공장 내부</div>
                  <div className="eng">Factory Interior</div>
                </div>
              </S.ImgHolderHarf>
              <div className="sale-bus-list flex-right">
                <div className="sale-bus-item sale-bus-item-full">
                  <img src={Bus1} alt="" className="sale-bus-img" />
                  <div className="sale-bus-name">BS106</div>
                </div>
                <div className="sale-bus-item sale-bus-item-full">
                  <img src={Bus2} alt="" className="sale-bus-img" />
                  <div className="sale-bus-name">G12</div>
                </div>
              </div>
            </S.ImgHolderFlex>

            <PageTitle titleko={"주요 이력"} titleeng={"Key History"} />
            <div className="page-text">
              <div className="page-text-flex">
                <div className="page-text-area">
                  <div className="page-text-title">
                    <div className="kor">Daewoo Bus Kazakhstan LLC. 법인개요</div>
                    <div className="eng">Daewoo Bus Kazakhstan LLC. Status</div>
                  </div>
                  <div className="kor">법인 설립: 2007년 2월 1일 (자일자동차 50% / 카자흐스탄 세마즈사 50%)</div>
                  <div className="eng">Established: 2007. 2. 1 (Zyle 50% / KZ Semaz 50%)</div>
                </div>
              </div>
              <div className="kor">
                ※ 공장규모: 부지/건물 5,205평 (임대)
                <br />
                ※ 연간 생산능력: 200대(8T 기준)
                <br />
                ※ 중대형 버스 생산/판매
              </div>
              <div className="eng">
                ※ Factory Size: land / building 17,200 square meters
                <br />
                ※ Annual production capa: 200 units(8T basis)
                <br />
                ※ Mid & Large bus manufacturing / sales
              </div>
              <br />
            </div>
          </div>
        </div>
      </section>
    </S.Page>
  );
};

export default Factory5;
